import { render, staticRenderFns } from "./ColMoreTextField.vue?vue&type=template&id=61ab43f7"
import script from "./ColMoreTextField.vue?vue&type=script&lang=js"
export * from "./ColMoreTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports